<div class="flex gap-2">
  <button
    [ngClass]="{
      'border-neutral-700': !isFeedbackType()[FeedbackType.NEGATIVE],
      'border-red-400': isFeedbackType()[FeedbackType.NEGATIVE],
      'cursor-pointer': canSendFeedback(),
    }"
    (click)="submitFeedback(FeedbackType.NEGATIVE)"
    class="group w-7 h-7 flex justify-center items-center border rounded"
  >
    <flx-icon
      [ngClass]="{
        'text-neutral-400': !isFeedbackType()[FeedbackType.NEGATIVE],
        'group-hover:text-neutral-50': canSendFeedback(),
        'text-red-400': isFeedbackType()[FeedbackType.NEGATIVE],
      }"
      name="thumbs-down"
    />
  </button>
  <button
    [ngClass]="{
      'border-neutral-700': !isFeedbackType()[FeedbackType.POSITIVE],
      'border-green-400': isFeedbackType()[FeedbackType.POSITIVE],
      'cursor-pointer': canSendFeedback(),
    }"
    (click)="submitFeedback(FeedbackType.POSITIVE)"
    class="group w-7 h-7 flex justify-center items-center border rounded"
  >
    <flx-icon
      [ngClass]="{
        'text-neutral-400': !isFeedbackType()[FeedbackType.POSITIVE],
        'group-hover:text-neutral-50': canSendFeedback(),
        'text-green-400': isFeedbackType()[FeedbackType.POSITIVE],
      }"
      name="thumbs-up"
    />
  </button>
</div>
